import { ActionButton, ComboBox, DefaultButton, getTheme, Panel, PrimaryButton, Stack, TextField, Text, Label } from '@fluentui/react';
import * as React from 'react';

interface IAddImageViewProps {
    onDismiss: () => void;
    iconUrl: any;
    onChanged: (files: FileList) => void;
    fileButtonClick: () => void;
    setDescription: (text: string) => void;
    description: string;
    save: () => void;
}

export const AddImageView: React.FC<IAddImageViewProps> = props => {

    const theme = getTheme();

    const handleDrop = (event:any) => {
        event.preventDefault();
        event.stopPropagation();
        const { files } = event.dataTransfer;
        if (files.length > 0) {
            props.onChanged(files);
        }
    }

    const handleDragOver = (event:any) => {
        event.preventDefault();
        event.stopPropagation();
    }
    const handleDragStart = (event:any) => {
        event.dataTransfer.setData("text/plain", event.target.id)
    }


    return (<Panel title="Vložení obrázku"
        onDismiss={props.onDismiss}
        isOpen={true}
    >
        <Stack tokens={{ childrenGap:5}}>
            <Stack horizontal verticalAlign="end">
                <Stack>
                    <ComboBox options={[]} label="Adresář" placeholder="Vyberte kam zařadit obrázek" />
                </Stack>
                <ActionButton iconProps={{ iconName:"Add" }} />
                <ActionButton iconProps={{ iconName: "Edit" }} />
            </Stack>
            <Text style={{ fontSize: 12, textDecoration:'italic' }}>Zadejte složku do které zařadit obrázek</Text>

            <input id="hiddenFileInput" type="file" onChange={(event) => {
                if (event && event.target && event.target.files) {
                    const files = event.target.files;
                    props.onChanged(files);
                }
            }}
                style={{ display: "none" }} accept="image/png, image/gif, image/jpeg" />
            <Label style={{
                color: "rgb(0, 125, 173)" }}>Obrázek</Label>
            <div style={{
                    borderWidth: 1  ,
                    borderStyle: 'dashed',
                    borderColor: theme.semanticColors.inputBorder,
                    minHeight: 100,
                    lineHeight: '30px',
                    textAlign: 'center',
                verticalAlign: 'center',
                padding:10
                }}
                    onClick={props.fileButtonClick}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}>
                {props.iconUrl ?
                    <img src={props.iconUrl} style={{ maxWidth: 200 }} onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = "/img/noimageicon.png";
                    }} /> : <span>Sem přetáhněte obrázek, nebo kliknutím ho vyberte </span>}

                </div>                 
            

            <TextField value={props.description} label="Popis" multiline onChange={(e, text) => { props.setDescription(text?text:"")}} />
            <Stack horizontal padding={10} tokens={{ childrenGap:5 }}>
                <PrimaryButton onClick={props.save}>Uložit</PrimaryButton>
                <DefaultButton onClick={props.onDismiss}>Zavřít</DefaultButton>
            </Stack>
        </Stack>
    </Panel>)

}